module.exports = __webpack_public_path__ + "media/assets/clock_field-ae0d6aa0d586b5d77afa3b3b8ff1205c.svg";